'use client';

import * as RadixCollapsible from '@radix-ui/react-collapsible';
import { ReactElement, useContext } from 'react';

import { cn } from '@/lib/utils/tailwind';

import {
  CollapsibleContext,
  CollapsibleContentProps,
  contentVariants,
} from './types';

export const CollapsibleContent = ({
  children,
  className,
  ...props
}: CollapsibleContentProps): ReactElement => {
  const { placement } = useContext(CollapsibleContext);

  return (
    <RadixCollapsible.Content
      className={cn(contentVariants({ placement }), className)}
      {...props}
    >
      {children}
    </RadixCollapsible.Content>
  );
};
